module.exports = __webpack_public_path__ + "static/media/Murmuratto_Template_Committee.3ed61be9.csv";